export const STAGGER = 0.1;

export const SKELETON = {
  name: { width: 96, height: 11, radius: 5 },
  value: { width: 40, height: 11, radius: 5 },
};
